module.exports = __webpack_public_path__ + "img/logo_h5.1640f716.png";